/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Upload_RetryInputs */

const en_doc_upload_retry = /** @type {(inputs: Doc_Upload_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const pt_br2_doc_upload_retry = /** @type {(inputs: Doc_Upload_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Doc_Upload_RetryInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_upload_retry = /** @type {((inputs?: Doc_Upload_RetryInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Upload_RetryInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_upload_retry(inputs)
	return pt_br2_doc_upload_retry(inputs)
});